import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router';

export const usePageTitle = (title) => {
    const [pageTitle, setPageTitle] = useState('');
    const intl = useIntl();
    const { pathname } = useLocation();
    useEffect(() => {
        if (pathname.includes('help-content')) {
            const h1Text = document.getElementsByTagName('h1')[0]?.textContent;
            setPageTitle(h1Text || intl.formatMessage({ id: title }));
        } else {
            setPageTitle(intl.formatMessage({ id: title }));
        }
    }, [intl, pathname, title]);
    return pageTitle;
};
